import styled from 'styled-components';
import Select from 'react-select';

export const SelectStyle = styled(Select)`
  width: 120px;
  float: right;
`;
